import { defineStore } from "pinia";
import { IHelpdesk } from "@/schemas/helpdesk/helpdeskSchema";

interface State {
  helpdesk: IHelpdesk;
}
export const useHelpdeskStore = defineStore("helpdeskStore", {
  state: (): State => ({
    helpdesk: {},
  }),
});
